// Damaged Products Mutations

export const updateDamagedProductsList = (state, payload) => {
  state.damagedProductsList = payload
}

export const fetchDamagedProductInfo = (state, payload) => {
  state.damagedProductInfo = payload
}

export const fetchDamagedProductsCount = (state, payload) => {
  state.damagedProductsCount = payload
}

export const fetchUnclosedDamagedProductsCount = (state, payload) => {
  state.unclosedDamagedProductsCount = payload
}
